var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTransactionFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transaction-Filled",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14692",
    "data-name": "Path 14692",
    d: "M14,11V8H1V4H14V1l7,5ZM3,18l7,5V20H23V16H10V13Z",
    fill: "#06f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransactionFilled);
export default __webpack_public_path__ + "static/media/icon-transaction-filled.d702a56c0ed520de5c30ee61dbcce45a.svg";
export { ForwardRef as ReactComponent };